import { FeatureDecisionsReturnType } from 'src/services/feauterDecisions';
import { modules } from '../constants';
import { EventBus } from '@schemeserve/global-utils';

declare global {
  interface Window {
    isFrontendEnabled: boolean;
    isLoggedIn: boolean;
    smartlook?: any;
    EventBus: EventBus;
  }
}

export const inIframe = (): boolean => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

export type Module = {
  module: JSX.Element;
  ref: string;
  isPreLogin: boolean;
};

export function createFeatureAwareRenderDecisions(
  featureDecisions: FeatureDecisionsReturnType,
): (module: Module) => boolean {
  return (data: Module) => {
    const renderConditions = {
      [modules.NOTIF_BANNER]: featureDecisions.notificationBannerShouldRender,
      [modules.QUESTIONS_EDITOR]: featureDecisions.qseShouldRender,
      [modules.ACCOUNTING]: featureDecisions.accountingShouldRender,
      [modules.USERS]: featureDecisions.usersShouldRender,
      [modules.EMAILS]: featureDecisions.emailShouldRender,
      [modules.PERMISSIONS]: featureDecisions.permissionsShouldRender,
      [modules.MACHINE_KEYS]: featureDecisions.machineKeysShouldRender,
      [modules.TRANSLATIONS_EDITOR]: featureDecisions.translationsEditorShouldRender,
      [modules.COOKIES_BAR]: featureDecisions.cookiesBarShouldRender,
      [modules.IMPORT_MAPPING]: featureDecisions.importMappingShouldRender,
      [modules.FILE_LOOKUPS]: featureDecisions.fileLookUpsShouldRender,
      [modules.EMAIL_TEMPLATES]: featureDecisions.emailTemplatesShouldRender,
      [modules.TOAST_CONTAINER]: featureDecisions.toastContainerShouldRender,
      [modules.TRACKING]: featureDecisions.trackingShouldRender,
      [modules.CHAT]: featureDecisions.chatShouldRender,
    };

    return renderConditions?.[data.ref]?.(data) ?? false;
  };
}
